import { Api } from "./base";

const _headers = { "Content-Type": "application/json" };

export default {
  getLogin(data) {
    return Api.post("/user/v1/login/", data, _headers);
  }
};
